import { FC, useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import MessageBus from '@restore/messagebus';
import Constants from '../../../constants/constants';
import { httpGet } from '../../../modules/api/axios_api';
import LoaderAnimation from '../LoaderAnimation';
import Analytics from '../../services/Analytics';

import { useParams } from 'react-router-dom';

interface CboardRouteParams {
  restorativeProgramId?: string; // Assuming the 'id' parameter is a string, change this based on your actual use case
}

const Iframe = styled.iframe`
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc((var(--vh, 1vh) * 100) - var(--siteHeaderHeight));
`;

const CboardDialog: FC = () => {
  const messageBus = new MessageBus();
  const [ssoAuthToken, setSsoAuthToken] = useState<string>();

  const { restorativeProgramId } = useParams<CboardRouteParams>();

  const apiUrl = import.meta.env.VITE_API_SERVER;
  // TODO: Set up typing for redux store

  const throttling = useRef(false);

  const keepAlive = (uuid: string) => {
    if (throttling.current) {
      return;
    }

    throttling.current = true;
    Analytics.reportWebSession('CBOARD', uuid);

    setTimeout(() => {
      throttling.current = false;
    }, 15000);
  };

  const updateHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  useEffect(() => {
    const headerHeight = document.querySelector('#site-header')?.clientHeight || '96px';
    updateHeight();

    window.addEventListener('resize', updateHeight);
    document.documentElement.style.setProperty('--siteHeaderHeight', `${headerHeight}px`);

    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  });

  useEffect(() => {
    if (ssoAuthToken) {
      messageBus.subscribe('keepalive', (payload) => {
        keepAlive(payload as string);
      });
    }
  }, [ssoAuthToken]);

  const attributeOnUnmount = async () => {
    const duration = await messageBus.request('stopTimer', {});
    if (duration === 0) {
      return;
    }

    if (restorativeProgramId && !isNaN(parseInt(restorativeProgramId))) {
      messageBus.publish('activityAttribution', {
        program: { id: parseInt(restorativeProgramId) },
        duration: Math.round((duration as number) / 1000),
        title: 'Cboard',
        activityType: 'CBOARD_ACTIVITY',
      });
    }
  };
  useEffect(() => {
    httpGet(`${apiUrl}/sso/cboard`, {}).then((response) => {
      setSsoAuthToken(response?.data.token);

      if (response?.data?.token && restorativeProgramId) {
        messageBus.publish('startTimer', {});
      }
    });

    return () => {
      attributeOnUnmount();
    };
  }, []);

  if (ssoAuthToken) {
    return <Iframe id="cboard-iframe" src={`${Constants.SSO_REDIRECT_URLS['cboard']}/sso/jwt/${ssoAuthToken}`} />;
  } else {
    return <LoaderAnimation />;
  }
};

export default CboardDialog;
